module.exports = __webpack_public_path__ + "img/ilustracion.a01dfaab.webp";